import React, { Component } from "react";

class PaddlerUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M12.5,12.4c-0.7-0.7-0.7-1.7,0-2.4c0.7-0.7,1.7-0.7,2.4,0s0.7,1.7,0,2.4S13.1,13,12.5,12.4z M22.6,21.5
	c-2.8,1.4-5.7,1.4-8.8,0L9,19c-3.4-1.5-6.2-1.5-8.4,0.1c-0.3,0.2-0.4,0.7-0.2,1c0.2,0.3,0.7,0.4,1,0.2c1.7-1.2,4-1.2,6.8,0.1
	l4.8,2.5c1.8,0.8,3.5,1.2,5.2,1.2c1.7,0,3.3-0.4,4.9-1.2c0.4-0.2,0.5-0.6,0.3-1C23.4,21.4,23,21.3,22.6,21.5z M4.7,15.8
	c0-0.3,0.2-0.7,0.5-0.8c2.2-0.8,3.7-2.7,4.7-5.8c0.4-1.6,1.5-3.1,3.5-4l-0.2-0.5c0,0,0,0,0-0.1c-0.7,0.2-1.5-0.2-1.8-0.9l-0.7-1.5
	c-0.4-0.8,0-1.8,0.8-2.2c0.8-0.4,1.8,0,2.2,0.8l0.7,1.5c0.3,0.7,0.1,1.5-0.5,2c0,0,0,0,0,0l0.3,0.7c0.2,0.1,0.4,0.2,0.5,0.5
	c0.1,0.2,0.1,0.4,0,0.6l3.6,7.6c0.3,0,0.5,0.2,0.6,0.5c0.1,0.2,0,0.5-0.1,0.7l0.5,1c0,0,0,0,0,0.1c0.7-0.2,1.5,0.2,1.8,0.9l0.7,1.5
	c0.1,0.1,0.1,0.3,0.1,0.4c0.2-0.1,0.4-0.1,0.6-0.2c0.4-0.2,0.8,0,1,0.3c0.2,0.4,0,0.8-0.3,1c-1.6,0.8-3.2,1.2-4.9,1.2
	c-1.7,0-3.4-0.4-5.2-1.2l-4.8-2.5c-1-0.5-2.1-0.8-3-0.9C5,16.4,4.8,16.2,4.7,15.8z M18.8,19.5l-0.6-1.3c-0.3-0.7-0.1-1.5,0.5-2
	c0,0,0,0,0,0l-0.4-0.9c-1.1,0.4-2,0.5-2.9,0.5c-1.3,0-2.4-0.3-3.2-0.9l-1.4,1.9l3.2,1.7C15.5,19.3,17.2,19.6,18.8,19.5z M11.5,11.9
	c0.6,1.7,2.6,3.1,6.1,2l-3.5-7.3C11.5,7.7,10.8,10.1,11.5,11.9z"
        />
      </svg>
    );
  }
}

export default PaddlerUpSVG;



// WEBPACK FOOTER //
// ./src/svg/PaddlerUpSVG.jsx